import "./about.4989c51c.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2745"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2745"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4AGbv = parcelRequire("4AGbv");

var $iNA1s = parcelRequire("iNA1s");

var $beOXE = parcelRequire("beOXE");
(0, $4AGbv.default).registerPlugin((0, $iNA1s.default), (0, $beOXE.default));
//nav animator
let $e73bf42412feb220$var$selectedLink = null;
const $e73bf42412feb220$var$nav = document.querySelector('.navbar');
function $e73bf42412feb220$var$animateIn(beforeSpan, listSpan) {
    const tl = (0, $4AGbv.default).timeline();
    tl.to(beforeSpan, {
        y: -40,
        duration: 0.3,
        overwrite: "auto"
    }).to(listSpan, {
        color: "#1E201E",
        duration: 0.3,
        overwrite: "auto"
    }, "<").to(listSpan, {
        "--after-opacity": 1,
        "--before-opacity": 1,
        duration: 0.3,
        overwrite: "auto"
    }, "<");
}
function $e73bf42412feb220$var$animateOut(beforeSpan, listSpan) {
    const tl = (0, $4AGbv.default).timeline();
    tl.to(beforeSpan, {
        y: 0,
        duration: 0.3,
        overwrite: "auto"
    }).to(listSpan, {
        color: "#000000",
        duration: 0.3,
        overwrite: "auto"
    }, "<").to(listSpan, {
        "--after-opacity": 1,
        "--before-opacity": 1,
        duration: 0.3,
        overwrite: "auto"
    }, "<");
}
document.addEventListener("DOMContentLoaded", function() {
    const LI = document.querySelectorAll(".navbar nav ul li");
    LI.forEach((li)=>{
        const listItem = li.querySelector("li");
        const link = li.querySelector("a");
        const beforeSpan = li.querySelector(".before-span");
        const listSpan = beforeSpan?.querySelector("span");
        if (!link || !beforeSpan || !listSpan) return;
        link.addEventListener("mouseenter", ()=>{
            if (link !== $e73bf42412feb220$var$selectedLink && $e73bf42412feb220$var$selectedLink) {
                const selectedBefore = $e73bf42412feb220$var$selectedLink.querySelector(".before-span");
                const selectedSpan = selectedBefore?.querySelector("span");
                if (selectedBefore && selectedSpan) $e73bf42412feb220$var$animateOut(selectedBefore, selectedSpan);
            }
            $e73bf42412feb220$var$animateIn(beforeSpan, listSpan);
        });
        link.addEventListener("mouseleave", ()=>{
            if (link !== $e73bf42412feb220$var$selectedLink) {
                $e73bf42412feb220$var$animateOut(beforeSpan, listSpan);
                if ($e73bf42412feb220$var$selectedLink) {
                    const selectedBefore = $e73bf42412feb220$var$selectedLink.querySelector(".before-span");
                    const selectedSpan = selectedBefore?.querySelector("span");
                    if (selectedBefore && selectedSpan) $e73bf42412feb220$var$animateIn(selectedBefore, selectedSpan);
                }
            }
        });
    });
    function logCurrentPageLink() {
        // e.g. ".../web-build/services/index.html" -> ["web-build", "services", "index.html"]
        const pathSegments = window.location.pathname.split("/").filter(Boolean);
        const currentFile = pathSegments[pathSegments.length - 1] || "index.html";
        const currentFolder = pathSegments.length > 1 ? pathSegments[pathSegments.length - 2] : null;
        console.log("Current page:", currentFile, "in folder:", currentFolder);
        const navLinks = document.querySelectorAll(".navbar ul li a");
        console.log("Found links:", navLinks.length);
        navLinks.forEach((link)=>{
            const href = link.getAttribute("href");
            if (!href) return;
            const hrefSegments = href.split("/").filter(Boolean);
            const hrefFile = hrefSegments[hrefSegments.length - 1];
            const hrefFolder = hrefSegments.length > 1 ? hrefSegments[hrefSegments.length - 2] : null;
            console.log("Checking href:", href, "-> file:", hrefFile, "folder:", hrefFolder);
            // Every page is named index.html, so the file name alone can't tell
            // pages apart — the parent folder has to match too.
            if (hrefFile === currentFile && hrefFolder === currentFolder) {
                console.log("Current page link:", link);
                $e73bf42412feb220$var$selectedLink = link;
                const beforeSpan = link.querySelector(".before-span");
                const listSpan = beforeSpan?.querySelector("span");
                console.log("there is a match at:", $e73bf42412feb220$var$selectedLink);
                if (beforeSpan && listSpan) $e73bf42412feb220$var$animateIn(beforeSpan, listSpan); // Animate default selected link
            }
        });
    }
    logCurrentPageLink();
});
const $e73bf42412feb220$var$content = document.querySelector('.smooth-content');
const $e73bf42412feb220$var$viewbox = document.querySelector('.viewbox');
// --- state ---
// let current  = 0;
// let target   = 0;  
// let maxScroll = 0;
// const ease = 0.2; 
// window.addEventListener('wheel', (e) => {
//     e.preventDefault();
//     const maxScroll = viewbox.scrollHeight - viewbox.clientHeight;
//     target += e.deltaY;
//     target = Math.max(0, Math.min(target, maxScroll));
//     }, { passive: false });
//     gsap.ticker.add(() => {
//     // lerp current toward target each frame
//     current = gsap.utils.interpolate(current, target, .1);
//     viewbox.scrollTop = current;
// });
// gsap.ticker.lagSmoothing(0); // prevents big jumps after tab loses focus
// // touch support
// let touchStartY = 0;
// window.addEventListener('touchstart', e => { touchStartY = e.touches[0].clientY; });
// window.addEventListener('touchmove', e => {
//     e.preventDefault();
//     const delta = touchStartY - e.touches[0].clientY;
//     touchStartY  = e.touches[0].clientY;
//     target = clamp(target + delta, 0, maxScroll);
// }, { passive: false });
//     window.addEventListener('wheel', (e) => {
//     e.preventDefault();
//     target = clamp(target + e.deltaY, 0, maxScroll);
//   gsap.to(content, {
//     y: -target,
//     duration: 1,
//     ease: 'power3.out',
//     overwrite: 'auto'
//   });
// }, { passive: false });
// Hamburger Menu Animation //
const $e73bf42412feb220$var$hamburger = document.querySelector(".hamburger");
const $e73bf42412feb220$var$navMenu = document.querySelector(".mobile-navbar");
const $e73bf42412feb220$var$mobileNav = document.getElementById('mobile-navbar');
const $e73bf42412feb220$var$navElements = $e73bf42412feb220$var$mobileNav.querySelectorAll('ul li');
if ($e73bf42412feb220$var$hamburger) $e73bf42412feb220$var$hamburger.addEventListener('click', ()=>{
    if ($e73bf42412feb220$var$navMenu.classList.contains('active')) $e73bf42412feb220$var$closeNav();
    else $e73bf42412feb220$var$openNav();
});
function $e73bf42412feb220$var$openNav() {
    $e73bf42412feb220$var$hamburger.classList.add('active');
    $e73bf42412feb220$var$navMenu.classList.add('active');
    $e73bf42412feb220$var$viewbox.classList.add('active');
}
function $e73bf42412feb220$var$closeNav() {
    $e73bf42412feb220$var$hamburger.classList.remove('active');
    $e73bf42412feb220$var$navMenu.classList.remove('active');
    $e73bf42412feb220$var$viewbox.classList.remove('active');
}
// Close the mobile menu when a nav link is clicked
const $e73bf42412feb220$var$navLinks = document.querySelectorAll('.list a');
$e73bf42412feb220$var$navLinks.forEach((link)=>{
    link.addEventListener('click', ()=>{
        $e73bf42412feb220$var$closeNav();
    });
});
const $e73bf42412feb220$var$mobileQuery = window.matchMedia('(max-width: 640px)');
$e73bf42412feb220$var$mobileQuery.addEventListener('change', (e)=>{
    if (!e.matches) $e73bf42412feb220$var$closeNav(); // crossed back to desktop
});
// Close menu on Escape key
document.addEventListener('keydown', (e)=>{
    if (e.key === 'Escape') $e73bf42412feb220$var$closeNav();
});
/* Mobile Nav Animation */ console.log("is this thing on?");


//# sourceMappingURL=web-build.50b9ce86.js.map
